import { render, staticRenderFns } from "./dangerGoodsLog.vue?vue&type=template&id=0cbc1d6d&scoped=true"
import script from "./dangerGoodsLog.vue?vue&type=script&lang=js"
export * from "./dangerGoodsLog.vue?vue&type=script&lang=js"
import style0 from "./dangerGoodsLog.vue?vue&type=style&index=0&id=0cbc1d6d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbc1d6d",
  null
  
)

export default component.exports